export default __webpack_public_path__ + "static/simonly-15fdbf2f756b46ca7a176953d3e575b7.jpg";